export default __webpack_public_path__ + "static/detail-9f434cd8ba166de7ff3a7ca6c7544a83.jpg";